<template>
    <v-sheet>
        <v-switch v-model="form.code.isOn" v-bind="{ ...attrs_switch, label }" dense class="ml-8" @change="emit" />
        <v-expand-transition>
            <v-sheet v-show="form.code.isOn">
                <v-text-field v-model="form.code.text" placeholder="참여코드를 입력해주세요" v-bind="attrs_input" class="mt-10" @input="emit" />
                <p class="font-size-14 grey--text text--lighten-2 mt-4">시청 시 참여코드를 입력해야 합니다.</p>
            </v-sheet>
        </v-expand-transition>
    </v-sheet>
</template>

<script>
import { initLecture } from "@/store/lecture/lecture.inits";
import { attrs_input, attrs_switch } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initLecture },
    },
    data: () => ({
        form: initLecture(),

        attrs_input,
        attrs_switch,
    }),
    computed: {
        label() {
            if (this.form.code.isOn) return "사용";
            else return "미사용";
        },
    },
    methods: {
        sync() {
            this.form = initLecture(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
